<section class="hero fluid-bg" id="home">
  <div class="container hero-container">
    <div class="hero-content reveal-left">
      @if (currentSlider(); as slider) {
        <div
          class="hero-badge reveal-left active delay-100"
          [@slideFade]="currentSliderIndex()"
        >
          {{ slider.title }}
        </div>
        <h1
          class="hero-title reveal-left active delay-200"
          [@slideFade]="currentSliderIndex()"
        >
          @for (segment of slider.heroTitleSegments; track $index) {
            <span [ngStyle]="segment.style">{{ segment.text }}</span>
          }
        </h1>
        @if (slider.heroSubtitle) {
          <p
            class="hero-subtitle reveal-left active delay-300"
            [@slideFade]="currentSliderIndex()"
          >
            @for (segment of slider.heroSubtitleSegments; track $index) {
              <span [ngStyle]="segment.style">{{ segment.text }}</span>
            }
          </p>
        }
      } @else {
        <div class="hero-badge reveal-left delay-100">
          Next-Gen Enterprise Telephony
        </div>
        <h1 class="hero-title reveal-left delay-200">
          KOTHA 09666 <span class="text-accent">IP-Telephony</span> Service
        </h1>
        <p class="hero-subtitle reveal-left delay-300">
          BDCOM launches "KOTHA", a reliable, robust IP Telephony Service with
          supreme voice quality, video calls, messaging, and competitive rates
          designed for the modern enterprise.
        </p>
      }

      <div class="hero-actions reveal-left delay-400">
        <a href="#services" class="btn btn-primary btn-lg">Explore Services</a>
        <a
          href="https://www.kotha.com.bd/helpdesk"
          class="btn btn-outline btn-lg"
          >Contact Helpdesk</a
        >
      </div>

      <div class="hero-features reveal-scale delay-400">
        <div class="feature-item feature-pill">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feature-icon"
          >
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
          <span>Free Net-to-Net</span>
        </div>
        <div class="feature-item feature-pill">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feature-icon"
          >
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
          <span>Crystal Clear</span>
        </div>
        <div class="feature-item feature-pill">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feature-icon"
          >
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
          <span>Zero Downtime</span>
        </div>
      </div>
    </div>

    <div class="hero-image-wrapper reveal-right delay-300">
      <div class="hero-graphic glass-card">
        @if (currentSlider(); as slider) {
          <img
            [src]="slider.image || 'assets/placeholder.png'"
            [alt]="slider.title"
            class="hero-img"
            [@slideFade]="currentSliderIndex()"
            (error)="$any($event.target).src = 'assets/placeholder.png'"
          />
        } @else {
          <img
            src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
            alt="Tech Dashboard"
            class="hero-img"
          />
        }
        <div class="floating-card support-card">
          <div class="icon-box">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
              ></path>
            </svg>
          </div>
          <div class="card-text">
            <strong>24/7 AI Support</strong>
            <span>Always online</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
